export default __webpack_public_path__ + "static/aboutBcg-254afe6eef670b809fcb1b966a60ba7f.jpg";